import { Document, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment';
import RutTools from '../../helpers/format-rut';
const styles = StyleSheet.create({
  page: {
    padding: 30,
  },
  container: {
    flexDirection: 'column',
    padding: 20,
  },
  header: {
    flexDirection: 'row',
    borderTop: 1,
    borderBottom: 0.5,
    borderLeft: 1,
    borderRight: 1,
    borderColor: 'black',
    backgroundColor: '#525659',
    color: 'white',
  },
  title: {
    fontSize: 14,
    fontWeight: 'bold',
    padding: 5,
  },
  content: {
    flexDirection: 'column',
    marginBottom: 10,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    border: 1,
    borderColor: 'black',
  },
  row2: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    border: 1,
    borderColor: 'black',
    height: 180,
  },
  label: {
    fontWeight: 'bold',
    fontSize: 11,
    padding: 5,
    borderColor: 'black',
    borderLeft: 1,
  },
  small_label: {
    fontWeight: 'bold',
    fontSize: 9,
    padding: 5,
    borderColor: 'black',
    borderLeft: 1,
  },
  value: {
    fontSize: 11,
    padding: 5,
    borderColor: 'black',
  },

  pageNumber: {
    position: 'absolute',
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
    fontSize: 10,
  },

  sectionBoxOneRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '10px',
  },

  imagesFirma: {
    width: '100px',
    height: '30px',
  },
});

interface IProps {
  imgFirma?: string;
  state: any;
}
const SignatureDeclarations = (prosp: IProps) => {
  // const {state } = useFormContext();
  const { state } = prosp;

  console.log('Hola este estado es el que se imprime en el pdf', state);

  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.container}>
          <View style={styles.header}>
            <Text style={styles.title}>INFORMACIÓN VEHÍCULO SINIESTRADO</Text>
          </View>
          <View style={styles.content}>
            <View style={styles.row}>
              <Text style={styles.label}>PATENTE VEHÍCULO SINIESTRADO:</Text>
              <Text style={styles.value}>{state.vehiclePatente?.deviceId}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>DIRECCIÓN DEL SINIESTRO:</Text>
              <Text style={styles.value}>{`${state.address?.streetAndNumber}, ${state.address?.city}`}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>FECHA Y HORA SINIESTRO:</Text>
              <Text style={styles.value}>
                {moment(state?.claimDate.toString()).format('DD/MM/YYYY')} {state?.claimTime}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>N° DE SEGUIMIENTO:</Text>
              <Text style={styles.value}>{state.shortId}</Text>
            </View>
          </View>

          <View style={styles.header}>
            <Text style={styles.title}>DATOS DEL CONDUCTOR:</Text>
          </View>
          <View style={styles.content}>
            <View style={styles.row}>
              <Text style={styles.label}>NOMBRE/ APELLIDO COMPLETO:</Text>
              <Text style={styles.value}>{state.driver?.fullName}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>RUT CONDUCTOR:</Text>
              <Text style={styles.value}>{RutTools.formatWithDots(state.driver?.identityNumber)}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>TERCEROS INVOLUCRADOS:</Text>
              <Text style={styles.value}>{state.thirdPartyInvolved?.propertyInvolved ? 'SI' : 'NO'}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>CULPABILIDAD:</Text>
              <Text style={styles.value}>{state.driver?.isConsideredGuilty ? 'SI' : 'NO'}</Text>
            </View>
          </View>

          <View style={styles.header}>
            <Text style={styles.title}>DESCRIPCIÓN DEL ACCIDENTE</Text>
          </View>
          <View style={styles.content}>
            {/* row2 solo aplica para 1000 caracteres, si desean mas de 1000 caracteres, row2 debe agragar mas height*/}
            <View style={styles.row2}>
              <Text style={styles.label}>{state?.description}</Text>
            </View>
          </View>

          <View style={styles.content}>
            <View style={styles.row}>
              <Text style={styles.small_label}>
                DECLARO BAJO JURAMENTO que la información aportada es expresión fiel de las circunstancias que dieron lugar a los hechos constitutivos
                del siniestro denunciados para el vehículo asegurado antes individualizado. Declaró expresamente, por el presente instrumento, que
                entiendo y acepto que cualquier reticencia o declaración falsa de mi parte, faculta expresamente a la Compañía Aseguradora para
                rechazar el pago de la indemnización reclamada. Lo Anterior conforme al deber del asegurado contemplado en la legislación vigente, de
                acreditar la ocurrencia del seso denunciado, declarando fielmente y sin reticencia, sus circunstancias y consecuencias. Declaro estar
                en conocimiento que la Compañía Aseguradora ejercerá las acciones legales que correspondan, por el delito de Fraude al Seguro. Cuando
                se obtuviere maliciosamente el pago dela indemnización ya sea por haber simulado la existencia el siniestro, por haberlo provocado
                intencionalmente; o por haber presentado a la Compañía Aseguradora en virtud de causas o circunstancias distintas, a las verdaderas,
                ocultando la cosa asegurada o aumentando fraudulentamente las perdidas sufridas. Finalmente queda establecido que esta declaración
                jurada no exime de la obligación del asegurado de dejar la correspondiente Denuncia policial en caso de Robo (total o parcial del
                vehículo) y Choque o Colisión con lesionados involucrados Conforme ala normativa vigente, en caso de siniestro de daños a su vehículo
                y/o de terceros, para efecto del seguro se reemplaza la constancia policial por esta declaración jurada simple, la cual debe lenar y
                firmar el asegurado o el conductor.
              </Text>
            </View>
          </View>

          <View style={styles.content}>
            <View style={styles.row}>
              <Text style={styles.label}>NOMBRE:{'                          '}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>FECHA:{'                          '}</Text>
              <Text style={styles.label}>RUT:{'                          '}</Text>
              {/* <Text style={styles.label}>FIRMA: {imgFirma ? <Image src={imgFirma} style={styles.imagesFirma} /> : ''}</Text> */}
              <Text style={styles.label}>FIRMA:{'                          '}</Text>
            </View>
          </View>
        </View>

        <View style={styles.pageNumber}>
          <Text render={({ pageNumber, totalPages }) => `${pageNumber}/${totalPages}`} />
        </View>
      </Page>
    </Document>
  );
};

export default SignatureDeclarations;
